(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-box"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('byb-root');
  if (!root) return;

  var dataEl = document.getElementById('byb-data');
  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    // A malformed blob used to blank the whole feature silently. Fail loud in
    // the console and leave step 1 rendered rather than a dead page.
    if (window.console) console.error('[build-your-box] could not parse section data', e);
    return;
  }
  if (!data || !data.boxes) return;

  // `toolChosen` is separate from `toolSet` because "Box only (empty)" is a real choice that
  // leaves toolSet null — null alone can't distinguish "chose the empty box" from "chose nothing".
  // `body` / `trim` are the two halves of the single Shopify Color option ("Black/Red"), split so
  // they can be chosen separately. `variant` stays the resolved source of truth for price, image
  // and the cart payload — the axes only ever feed into it.
  // `width` is the step-1 FILTER, not a commitment: null means "All widths".
  var state = {
    width: null, box: null, variant: null, body: null, trim: null,
    application: null, toolSet: null, toolChosen: false, step: '1'
  };

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) { return ESCAPES[c]; });
  }

  // Product titles run to four figures on this collection — "$1750.00" reads
  // badly next to a freight-priced catalog, so group the thousands.
  var formatter = null;
  try {
    formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: data.currency || 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  } catch (e) { /* fall through to the plain formatter below */ }
  function money(value) {
    var n = Number(value) || 0;
    return formatter ? formatter.format(n) : '$' + n.toFixed(2);
  }

  // -------------------------------------------------------------------------
  // Price / image / variant resolution. All three follow the chosen variant, not
  // the product default — variants can be priced differently and can carry their
  // own photo.
  // -------------------------------------------------------------------------
  function boxPrice() {
    return Number(state.variant ? state.variant.price : (state.box && state.box.price)) || 0;
  }
  function boxImage() {
    return (state.variant && state.variant.image) || (state.box && (state.box.thumb || state.box.image)) || '';
  }
  function boxVariantId() {
    return state.variant ? state.variant.id : (state.box && state.box.variantId);
  }
  function runningTotal() {
    return boxPrice() + (state.toolSet ? Number(state.toolSet.price) || 0 : 0);
  }

  // -------------------------------------------------------------------------
  // Spec parsing.
  //
  // custom.dimensions is NOT usable here — it holds the width string ("45\"")
  // and just duplicates the size tag. custom.specs_dims is the field with real
  // geometry, and as of 2026-08-14 exactly one of the 32 Pro Series products has
  // it filled in, so every one of these parsers has to degrade to nothing.
  // -------------------------------------------------------------------------
  var DIM_RE = /([\d][\d\s\-\/]*)"\s*W\s*x\s*([\d][\d\s\-\/]*)"\s*D\s*x\s*([\d][\d\s\-\/]*)"\s*H/i;
  function parseDims(specs) {
    var m = DIM_RE.exec(String(specs || ''));
    if (!m) return null;
    // Collapse the runs of whitespace inside fractional inches ("36 1/8") so the
    // line reads as one measurement rather than three.
    function tidy(s) { return s.replace(/\s+/g, ' ').trim(); }
    return tidy(m[1]) + '"W x ' + tidy(m[2]) + '"D x ' + tidy(m[3]) + '"H';
  }
  function parseWeight(specs) {
    var m = /Weight:\s*([\d.,]+)\s*lbs?/i.exec(String(specs || ''));
    return m ? m[1].replace(/[.,]$/, '') + ' lbs' : null;
  }
  // Piece count comes off the title, not specs_dims — "233-Pieces" / "160-Piece"
  // is in every master-set name and is present even when the metafield isn't.
  function parsePieces(title) {
    var m = /(\d+)\s*-?\s*Piece/i.exec(String(title || ''));
    return m ? m[1] + ' pieces' : null;
  }

  // "Garage Top for 72\" 14-Drawer Rolling Tool Box" is an accessory, not a box —
  // parsing the whole title gave it a phantom "14 Drawers / Rolling Cabinet"
  // spec line. Only the part before " for " describes the product itself.
  function productSubject(title) {
    return String(title || '').split(/\s+for\s+/i)[0];
  }
  function parseDrawerCount(title) {
    var m = productSubject(title).match(/(\d+)\s*-?\s*Drawer/i);
    return m ? parseInt(m[1], 10) : null;
  }
  function parseConfigType(title) {
    var subject = productSubject(title);
    if (/workstation/i.test(subject)) return 'Workstation';
    if (/chest/i.test(subject)) return 'Tool Chest';
    if (/service cart/i.test(subject)) return 'Service Cart';
    if (/rolling/i.test(subject)) return 'Rolling Cabinet';
    return '';
  }
  // An accessory is titled "<thing> for <NN>" <box>" — a real box never is. This
  // catches the Garage Top without waiting on a tag being added in the admin.
  function isAccessory(title) {
    return /\s+for\s+\d+\s*["”]/i.test(String(title || ''));
  }

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  // Parse the date by hand rather than through `new Date(str)` — that parses a
  // bare ISO date as UTC midnight, which renders as the previous day in every US
  // timezone. A restock date that reads a day early is worse than no date at all.
  //
  // Two shapes are accepted because the store carries both: tool sets use a real
  // `date` metafield (custom.eta2 -> "2026-11-23") while boxes use a text field
  // (custom.eta -> "7/13/2026"). Only the first reaches this section today, but
  // the mapping is about to be recurated and the other costs one branch.
  function etaLabel(eta) {
    var s = String(eta || '').trim();
    var y, mo, d;
    var iso = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(s);
    var us = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(s);
    if (iso) { y = iso[1]; mo = Number(iso[2]); d = Number(iso[3]); }
    else if (us) { y = us[3]; mo = Number(us[1]); d = Number(us[2]); }
    else return 'Backordered';
    var month = MONTHS[mo - 1];
    if (!month || !d) return 'Backordered';
    return 'Ships ' + month + ' ' + d;
  }

  // Shared by the tool cards, the summary lines and the total bar so all three
  // stay the same size. Products without a featured image still get an empty tile
  // — otherwise rows lose their left alignment and the list looks ragged.
  function thumb(src) {
    if (!src) return '<span class="byb-thumb byb-thumb--empty" aria-hidden="true"></span>';
    return '<span class="byb-thumb"><img src="' + esc(src) +
      '" alt="" loading="lazy" decoding="async" width="160" height="160"></span>';
  }

  // Boxo colours are two-tone ("Black/Red"). Render a split chip when both halves map to a known
  // colour; otherwise fall back to the label alone, so a product whose option isn't a colour at
  // all still gets a working picker. Only values from this fixed map reach the inline style.
  var COLOR_WORDS = {
    black: '#16181C', white: '#ffffff', red: '#C30E23', blue: '#1b4b8f',
    grey: '#8a8a8a', gray: '#8a8a8a', silver: '#c9c9c9', chrome: '#c9c9c9',
    orange: '#e2650f', green: '#1f7a3f', yellow: '#e8c31a'
  };
  function swatch(title) {
    var parts = String(title || '').split('/').map(function (p) {
      return COLOR_WORDS[p.trim().toLowerCase()];
    });
    var a = parts[0];
    var b = parts.length > 1 ? parts[1] : parts[0];
    if (!a || !b) return '';
    var fill = a === b ? a : 'linear-gradient(135deg,' + a + ' 0 50%,' + b + ' 50% 100%)';
    return '<span class="byb-swatch" style="background:' + fill + '" aria-hidden="true"></span>';
  }

  // Boxo ships body and trim as ONE Shopify option whose values are already pairs — "Black/Red",
  // "White/Blue" — with all four combinations present on every Pro Series box. Splitting on the
  // slash gives two independent pickers that resolve straight back to the real variant, with no
  // product changes needed. "Handle Color" is Boxo's own name for the trim half: one product in
  // the catalog already uses split options named "Box Color:" / "Handle Color:".
  //
  // Returns null when the titles aren't pairs (single-colour products, "Default Title", or a
  // product that genuinely carries two Shopify options) — callers fall back to the flat picker,
  // so nothing here can strand a product without a way to choose.
  function splitAxes(variants) {
    if (!variants || variants.length < 2) return null;
    var bodies = [], trims = [], byPair = {};
    for (var i = 0; i < variants.length; i++) {
      var parts = String(variants[i].title || '').split('/');
      if (parts.length !== 2) return null;
      var body = parts[0].trim(), trim = parts[1].trim();
      if (!body || !trim) return null;
      if (bodies.indexOf(body) === -1) bodies.push(body);
      if (trims.indexOf(trim) === -1) trims.push(trim);
      byPair[body + '/' + trim] = variants[i];
    }
    // Two pickers only make sense if both axes actually offer a choice.
    if (bodies.length < 2 && trims.length < 2) return null;
    return { bodies: bodies, trims: trims, byPair: byPair };
  }

  // Resolve the two axes back to a real variant. Falls back to any variant sharing the chosen
  // body so a customer can never land on a combination that doesn't exist — though on the current
  // catalog every body/trim pair is stocked, so the fallback should stay unused.
  function resolveVariant(axes, body, trim) {
    return axes.byPair[body + '/' + trim] ||
      axes.byPair[body + '/' + axes.trims[0]] ||
      axes.byPair[axes.bodies[0] + '/' + axes.trims[0]];
  }

  // -------------------------------------------------------------------------
  // Step navigation
  // -------------------------------------------------------------------------
  var STEP_ORDER = ['1', '2', '3'];

  function showStep(name, opts) {
    if (STEP_ORDER.indexOf(name) === -1) return;
    // Never let a deep link or a stray call land on a step the state can't fill.
    if (name !== '1' && !state.box) name = '1';
    if (name === '3' && !state.toolChosen) name = '2';

    state.step = name;
    root.querySelectorAll('.byb-step').forEach(function (el) {
      el.classList.toggle('is-active', el.dataset.step === name);
    });

    renderTrail();
    renderTotalBar();
    writeUrl();

    var panel = root.querySelector('.byb-step.is-active');
    if (!panel) return;
    if (opts && opts.silent) return;

    // Steps swap in place, so a customer who taps a card near the bottom of a
    // long grid otherwise lands mid-page on content that starts above the fold,
    // and it reads as "nothing happened". Only scroll when the top of the
    // section has actually gone past — don't yank the page when it's in view.
    if (root.getBoundingClientRect().top < 0) {
      try {
        root.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
      } catch (e) {
        root.scrollIntoView(true);
      }
    }
    var heading = panel.querySelector('h2');
    if (heading) {
      try { heading.focus({ preventScroll: true }); } catch (e) { heading.focus(); }
    }
  }

  function setPressed(buttons, selected) {
    buttons.forEach(function (b) {
      var isSelected = b === selected;
      b.classList.toggle('is-selected', isSelected);
      if (b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  root.querySelectorAll('[data-back]').forEach(function (btn) {
    btn.addEventListener('click', function () { showStep(btn.dataset.back); });
  });

  // -------------------------------------------------------------------------
  // Trail — the clickable record of what has been chosen so far.
  // -------------------------------------------------------------------------
  function colourLabel() {
    if (state.body && state.trim) return state.body + ' / ' + state.trim;
    var t = state.variant && state.variant.title;
    return t && t !== 'Default Title' ? t : null;
  }

  function renderTrail() {
    var list = document.getElementById('byb-trail-list');
    if (!list) return;

    var toolLabel = null;
    if (state.toolChosen) toolLabel = state.toolSet ? state.toolSet.title : 'Box only';
    var colour = colourLabel();
    var step2Value = [colour, toolLabel].filter(Boolean).join(' · ') || '—';

    var crumbs = [
      { step: '1', label: 'Box', value: state.box ? state.box.title : 'Choose a box', done: !!state.box },
      { step: '2', label: 'Colour & tools', value: step2Value, done: state.toolChosen },
      { step: '3', label: 'Review', value: state.toolChosen ? money(runningTotal()) : '—', done: false }
    ];

    var activeIndex = STEP_ORDER.indexOf(state.step);

    list.innerHTML = crumbs.map(function (c, i) {
      var isActive = c.step === state.step;
      // Reachable = already visited, or the step we're on. An unreachable crumb
      // renders as a <span> so it is not focusable, rather than a disabled button
      // that keyboard users still have to tab through.
      var reachable = i <= activeIndex || c.done;
      var cls = 'byb-crumb' + (isActive ? ' is-active' : '') + (c.done && !isActive ? ' is-done' : '');
      var inner = '<span class="byb-crumb-n">' + (i + 1) + '</span>' +
        '<span class="byb-crumb-body">' +
          '<span class="byb-crumb-label">' + esc(c.label) + '</span>' +
          '<span class="byb-crumb-value">' + esc(c.value) + '</span>' +
        '</span>';
      var el = (reachable && !isActive)
        ? '<button type="button" class="' + cls + '" data-goto="' + c.step + '">' + inner + '</button>'
        : '<span class="' + cls + '"' + (isActive ? ' aria-current="step"' : '') + '>' + inner + '</span>';
      return '<li class="byb-crumb-item">' + el + '</li>';
    }).join('');

    Array.prototype.slice.call(list.querySelectorAll('[data-goto]')).forEach(function (btn) {
      btn.addEventListener('click', function () { showStep(btn.dataset.goto); });
    });
  }

  // -------------------------------------------------------------------------
  // Sticky running total — visible from the moment a box is chosen.
  // -------------------------------------------------------------------------
  var totalBar = document.getElementById('byb-total-bar');
  var totalBarThumb = document.getElementById('byb-total-bar-thumb');
  var totalBarItems = document.getElementById('byb-total-bar-items');
  var totalBarAmount = document.getElementById('byb-total-bar-amount');
  var totalBarCta = document.getElementById('byb-total-bar-cta');

  function renderTotalBar() {
    if (!totalBar) return;
    // Step 3 already shows the itemised total as the whole screen; a second copy
    // floating over the CTA is noise, and it would cover the add-to-cart button.
    if (!state.box || state.step === '3') { totalBar.hidden = true; return; }

    totalBar.hidden = false;
    if (totalBarThumb) totalBarThumb.innerHTML = thumb(boxImage());

    var bits = [state.box.title];
    var colour = colourLabel();
    if (colour) bits.push(colour);
    if (state.toolChosen) bits.push(state.toolSet ? state.toolSet.title : 'Box only');
    if (totalBarItems) totalBarItems.textContent = bits.join(' · ');

    if (totalBarAmount) totalBarAmount.textContent = money(runningTotal());

    if (totalBarCta) {
      var canReview = state.toolChosen;
      totalBarCta.textContent = canReview ? 'Review →' : 'Choose tools →';
      totalBarCta.disabled = false;
      totalBarCta.dataset.goto = canReview ? '3' : '2';
    }
  }

  if (totalBarCta) {
    totalBarCta.addEventListener('click', function () {
      var target = totalBarCta.dataset.goto || '2';
      if (target === '3') renderSummary();
      showStep(target);
    });
  }

  // -------------------------------------------------------------------------
  // URL state — lets a build be shared, reopened, printed or sent for a quote.
  // Deliberately in the hash rather than the query string: it never reaches the
  // server, never varies a cacheable URL, and never lands in analytics as a
  // distinct page.
  // -------------------------------------------------------------------------
  function writeUrl() {
    if (!window.history || !window.history.replaceState) return;
    var parts = [];
    if (state.box) parts.push('b=' + encodeURIComponent(state.box.id));
    if (state.variant) parts.push('v=' + encodeURIComponent(state.variant.id));
    if (state.toolChosen) parts.push('t=' + encodeURIComponent(state.toolSet ? state.toolSet.id : 'none'));
    if (state.width) parts.push('w=' + encodeURIComponent(state.width));
    if (state.step !== '1') parts.push('s=' + encodeURIComponent(state.step));
    var hash = parts.length ? '#byb:' + parts.join('&') : '';
    try {
      history.replaceState(null, '', location.pathname + location.search + hash);
    } catch (e) { /* a blocked replaceState must not break the builder */ }
  }

  function readUrl() {
    var h = String(location.hash || '');
    if (h.indexOf('#byb:') !== 0) return null;
    var out = {};
    h.slice(5).split('&').forEach(function (pair) {
      var kv = pair.split('=');
      if (kv.length === 2) out[kv[0]] = decodeURIComponent(kv[1]);
    });
    return out;
  }

  // Restore a shared build. Every lookup is defensive: a product that has since
  // been unpublished, sold out or repriced must drop the customer back into a
  // working builder rather than a half-restored one.
  function restoreFromUrl() {
    var q = readUrl();
    if (!q) return false;

    if (q.w) {
      var w = parseInt(q.w, 10);
      if (w) state.width = w;
    }
    if (!q.b) return false;

    var box = data.boxes.filter(function (b) { return String(b.id) === String(q.b); })[0];
    if (!box) return false;
    state.box = box;

    var variants = box.variants || [];
    state.variant = variants.filter(function (v) { return String(v.id) === String(q.v); })[0] || variants[0] || null;
    var seed = String((state.variant && state.variant.title) || '').split('/');
    state.body = seed.length === 2 ? seed[0].trim() : null;
    state.trim = seed.length === 2 ? seed[1].trim() : null;

    if (q.t) {
      if (q.t === 'none') {
        state.toolSet = null;
        state.toolChosen = true;
      } else {
        var set = (box.toolSets || []).filter(function (s) { return String(s.id) === String(q.t); })[0];
        if (set) { state.toolSet = set; state.toolChosen = true; }
      }
    }

    syncWidthChips();
    renderBoxGrid();
    renderChosenBox();
    renderToolOptions();
    if (state.toolChosen) renderSummary();

    var target = q.s && STEP_ORDER.indexOf(q.s) > -1 ? q.s : '2';
    showStep(target, { silent: true });
    return true;
  }

  // -------------------------------------------------------------------------
  // Step 1 — width filter + box grid
  // -------------------------------------------------------------------------
  var widthChips = Array.prototype.slice.call(root.querySelectorAll('.byb-filter-chip'));
  var boxCountEl = document.getElementById('byb-box-count');

  function syncWidthChips() {
    var want = state.width ? String(state.width) : '';
    var match = widthChips.filter(function (c) { return (c.dataset.size || '') === want; })[0];
    if (match) setPressed(widthChips, match);
  }

  widthChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      setPressed(widthChips, chip);
      var raw = chip.dataset.size || '';
      state.width = raw ? parseInt(raw, 10) : null;
      renderBoxGrid();
      writeUrl();
    });
  });

  function visibleBoxes() {
    return data.boxes.filter(function (b) {
      if (!(b.size > 0)) return false;
      if (isAccessory(b.title)) return false;
      if (state.width && b.size > state.width) return false;
      return true;
    }).sort(function (a, b) { return b.size - a.size; });
  }

  function renderBoxGrid() {
    var grid = document.getElementById('byb-box-grid');
    if (!grid) return;
    var matches = visibleBoxes();

    if (boxCountEl) {
      boxCountEl.textContent = state.width
        ? matches.length + (matches.length === 1 ? ' box fits' : ' boxes fit') + ' a ' + state.width + '" space'
        : matches.length + (matches.length === 1 ? ' box' : ' boxes') + ' available';
    }

    if (!matches.length) {
      grid.innerHTML = '<p class="byb-empty">Nothing in the Pro Series fits ' + esc(state.width) +
        '" of width right now. Try a wider space, or <a href="' + esc(data.collectionUrl) +
        '">browse the full Pro Series</a>.</p>';
      return;
    }

    grid.innerHTML = matches.map(function (b) {
      var drawers = parseDrawerCount(b.title);
      var config = parseConfigType(b.title);
      // Real geometry when the metafield carries it, the width alone otherwise.
      // Only one Pro Series product has specs_dims populated today, so this line
      // is mostly the fallback — filling the rest in is a content job.
      var dims = parseDims(b.specs);
      var weight = parseWeight(b.specs);
      var dimLine = dims ? (dims + (weight ? ' · ' + weight : '')) : (b.size + '" wide');
      var selected = state.box && String(state.box.id) === String(b.id);

      return '<button type="button" class="byb-box-card' + (selected ? ' is-selected' : '') +
        '" data-box-id="' + esc(b.id) + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' +
        '<span class="byb-box-card-figure' + (b.image ? '' : ' byb-box-card-figure--empty') + '">' +
          (b.image ? '<img src="' + esc(b.image) + '" alt="" loading="lazy" decoding="async" width="600" height="450">' : '') +
          (b.bestSeller ? '<span class="byb-badge">Best Seller</span>' : '') +
        '</span>' +
        '<span class="byb-box-card-body">' +
          '<span class="byb-box-card-title">' + esc(b.title) + '</span>' +
          '<span class="byb-box-meta">' +
            (config ? '<span>' + esc(config) + '</span>' : '') +
            (drawers ? '<span>' + esc(drawers) + ' Drawers</span>' : '') +
          '</span>' +
          '<span class="byb-box-dims">' + esc(dimLine) + '</span>' +
          '<span class="byb-box-card-price">' + money(b.price) + '</span>' +
        '</span>' +
        '</button>';
    }).join('');

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.byb-box-card'));
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        setPressed(cards, card);
        state.box = matches.filter(function (b) { return String(b.id) === card.dataset.boxId; })[0];
        state.toolSet = null;
        state.toolChosen = false;
        // Default to the first available variant — same product the section added before the
        // picker existed, so ignoring the picker changes nothing.
        state.variant = (state.box && state.box.variants && state.box.variants[0]) || null;
        // Seed both colour axes off that same variant, so the two pickers open already showing
        // what the customer is actually getting rather than nothing selected.
        var seed = String((state.variant && state.variant.title) || '').split('/');
        state.body = seed.length === 2 ? seed[0].trim() : null;
        state.trim = seed.length === 2 ? seed[1].trim() : null;
        renderChosenBox();
        renderToolOptions();
        showStep('2');
      });
    });
  }

  // -------------------------------------------------------------------------
  // Step 2 — chosen box, colour axes, tool sets
  // -------------------------------------------------------------------------
  function renderChosenBox() {
    var wrap = document.getElementById('byb-chosen-box');
    if (!wrap) return;
    if (!state.box) { wrap.innerHTML = ''; return; }

    var variants = state.box.variants || [];
    var axes = splitAxes(variants);
    var picker = '';

    function axisMarkup(label, values, selected, attr) {
      return '<p class="byb-variant-label">' + esc(label) + '</p>' +
        '<div class="byb-variant-options" role="group" aria-label="' + esc(label) + '">' +
        values.map(function (v) {
          var on = v === selected;
          return '<button type="button" class="byb-variant-option' + (on ? ' is-selected' : '') +
            '" data-' + attr + '="' + esc(v) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
            swatch(v) + '<span>' + esc(v) + '</span></button>';
        }).join('') + '</div>';
    }

    if (axes) {
      picker = axisMarkup('Box Color', axes.bodies, state.body, 'body') +
        axisMarkup('Handle Color', axes.trims, state.trim, 'trim');
    } else if (variants.length > 1) {
      // Fallback: the values aren't body/trim pairs, so offer the variant titles as they come.
      // Don't show a picker that offers a single option, and don't show "Default Title" as
      // if it were a colour.
      picker = '<p class="byb-variant-label">' + esc(state.box.optionName || 'Options') + '</p>' +
        '<div class="byb-variant-options" role="group" aria-label="' + esc(state.box.optionName || 'Options') + '">' +
        variants.map(function (v) {
          var on = state.variant && String(state.variant.id) === String(v.id);
          return '<button type="button" class="byb-variant-option' + (on ? ' is-selected' : '') +
            '" data-variant-id="' + esc(v.id) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
            swatch(v.title) + '<span>' + esc(v.title) + '</span></button>';
        }).join('') + '</div>';
    }

    var dims = parseDims(state.box.specs);
    var weight = parseWeight(state.box.specs);
    var dimLine = dims ? (dims + (weight ? ' · ' + weight : '')) : (state.box.size + '" wide');

    wrap.innerHTML = thumb(boxImage()) +
      '<div class="byb-chosen-body">' +
        '<p class="byb-chosen-eyebrow">Your box</p>' +
        '<p class="byb-chosen-title">' + esc(state.box.title) + '</p>' +
        '<p class="byb-chosen-price">' + money(boxPrice()) + '</p>' +
        '<p class="byb-chosen-dims">' + esc(dimLine) + '</p>' +
        picker +
      '</div>';

    // Both axes and the flat fallback funnel through the same commit step, so price, image and
    // the cart payload can't drift apart between the two rendering paths.
    function commit(next) {
      if (!next) return;
      state.variant = next;
      // Variants can be priced differently, so every price on screen has to follow.
      renderChosenBox();
      renderToolOptions();
      renderTrail();
      renderTotalBar();
      writeUrl();
    }

    if (axes) {
      Array.prototype.slice.call(wrap.querySelectorAll('[data-body]')).forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.body = btn.dataset.body;
          commit(resolveVariant(axes, state.body, state.trim));
        });
      });
      Array.prototype.slice.call(wrap.querySelectorAll('[data-trim]')).forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.trim = btn.dataset.trim;
          commit(resolveVariant(axes, state.body, state.trim));
        });
      });
    } else {
      Array.prototype.slice.call(wrap.querySelectorAll('.byb-variant-option')).forEach(function (btn) {
        btn.addEventListener('click', function () {
          commit(variants.filter(function (v) { return String(v.id) === btn.dataset.variantId; })[0]);
        });
      });
    }
  }

  // Application chips RECOMMEND, they do not hide.
  //
  // The tags are real — the 233-Piece set carries AUTOMOTIVE, MOTOCROSS,
  // MOTORCYCLE and OFF-ROAD; the 160-Piece carries AUTOMOTIVE — but three of the
  // seven chips (UTV, MARINE, MANUFACTURING) match neither set that is currently
  // wired into eligible_tool_sets. Hard filtering on those would empty step 2 and
  // dead-end the customer on the exact screen the attach rate depends on. So a
  // match promotes a set to the top of the list and badges it; a non-match still
  // shows. Switch to true filtering once the per-box curation is broad enough
  // that every chip has something to land on.
  function matchesApplication(set) {
    if (!state.application) return false;
    var tags = set.tags || [];
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toUpperCase() === state.application) return true;
    }
    return false;
  }

  var appChips = Array.prototype.slice.call(root.querySelectorAll('.byb-app-chip'));
  appChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      setPressed(appChips, chip);
      state.application = chip.dataset.app || null;
      renderToolOptions();
    });
  });

  function renderToolOptions() {
    var wrap = document.getElementById('byb-tool-options');
    if (!wrap || !state.box) return;
    var sets = (state.box.toolSets || []).slice();
    var emptyPrice = boxPrice();

    // Recommended sets float to the top. Stable within each group — Array.sort is
    // stable in every browser this ships to, so the curated order is preserved.
    if (state.application) {
      sets.sort(function (a, b) {
        return (matchesApplication(b) ? 1 : 0) - (matchesApplication(a) ? 1 : 0);
      });
    }

    // "Box only" shows the box itself, so the row reads as "just this, nothing added".
    var markup = ['<button type="button" class="byb-tool-card" data-tool-id="" aria-pressed="false">' +
      thumb(boxImage()) +
      '<span class="byb-tool-card-text"><span class="byb-tool-card-name">Box only (empty)</span>' +
      '<span class="byb-tool-card-metaline"><span>No tools</span></span></span>' +
      '<span class="byb-tool-card-price"><span class="byb-tool-card-price-label">Build total</span>' +
      '<span class="byb-tool-card-price-amount">' + money(emptyPrice) + '</span></span></button>'];

    sets.forEach(function (s) {
      // Out-of-stock sets stay selectable and carry their restock date instead of disappearing.
      // These are freight builds with long lead times anyway, so a date is a real offer — and
      // hiding them left almost every box showing the same two sets.
      var stock = s.available === false
        ? '<span class="byb-tool-card-stock">' + esc(etaLabel(s.eta)) + '</span>'
        : '';

      var meta = [];
      if (matchesApplication(s)) {
        meta.push('<span class="byb-rec">Built for ' + esc(state.application) + '</span>');
      }
      var pieces = parsePieces(s.title);
      if (pieces) meta.push('<span>' + esc(pieces) + '</span>');
      var setWeight = parseWeight(s.specs);
      if (setWeight) meta.push('<span>' + esc(setWeight) + '</span>');

      markup.push('<button type="button" class="byb-tool-card' +
        (s.available === false ? ' is-backorder' : '') +
        '" data-tool-id="' + esc(s.id) + '" aria-pressed="false">' +
        thumb(s.thumb) +
        '<span class="byb-tool-card-text">' +
          '<span class="byb-tool-card-name">' + esc(s.title) + '</span>' +
          (meta.length ? '<span class="byb-tool-card-metaline">' + meta.join('') + '</span>' : '') +
          stock +
        '</span>' +
        '<span class="byb-tool-card-price"><span class="byb-tool-card-price-label">Build total</span>' +
          '<span class="byb-tool-card-price-amount">' + money(emptyPrice + Number(s.price)) + '</span></span></button>');
    });
    wrap.innerHTML = markup.join('');

    var toolCards = Array.prototype.slice.call(wrap.querySelectorAll('.byb-tool-card'));

    // A variant or application change re-renders this list; don't silently drop a
    // tool set the customer already picked just because prices had to be
    // recalculated or the order changed.
    if (state.toolChosen) {
      var chosenId = state.toolSet ? String(state.toolSet.id) : '';
      var keep = toolCards.filter(function (c) { return c.dataset.toolId === chosenId; })[0];
      if (keep) setPressed(toolCards, keep);
    }
    syncToolsContinue();

    toolCards.forEach(function (card) {
      card.addEventListener('click', function () {
        setPressed(toolCards, card);
        var id = card.dataset.toolId;
        state.toolSet = id ? sets.filter(function (s) { return String(s.id) === id; })[0] : null;
        state.toolChosen = true;
        // Selection no longer navigates — the customer moves on via the continue button below,
        // so they can compare sets and change their mind without being thrown to the review screen.
        syncToolsContinue();
        renderTrail();
        renderTotalBar();
        writeUrl();
      });
    });
  }

  var toolsContinueBtn = document.getElementById('byb-tools-continue');
  function syncToolsContinue() {
    if (toolsContinueBtn) toolsContinueBtn.disabled = !state.toolChosen;
  }
  if (toolsContinueBtn) {
    toolsContinueBtn.addEventListener('click', function () {
      if (!state.toolChosen || !state.box) return;
      renderSummary();
      showStep('3');
    });
  }

  // -------------------------------------------------------------------------
  // Step 3 — review
  // -------------------------------------------------------------------------
  function renderSummary() {
    var summary = document.getElementById('byb-summary');
    if (!summary || !state.box) return;
    var total = boxPrice();
    // Name the chosen variant on the review line so the customer confirms the colour they picked
    // (or the default they accepted) before a freight item goes into the cart.
    var variantNote = '';
    var chosenTitle = state.variant ? state.variant.title : state.box.variantTitle;
    if (chosenTitle && chosenTitle !== 'Default Title') {
      variantNote = ' <span class="byb-variant-note">(' + esc(chosenTitle) + ')</span>';
    }
    var lines = ['<div class="byb-summary-line">' +
      '<span class="byb-summary-item">' + thumb(boxImage()) +
      '<span class="byb-summary-name">' + esc(state.box.title) + variantNote + '</span></span>' +
      '<span class="byb-summary-price">' + money(total) + '</span></div>'];
    if (state.toolSet) {
      total += Number(state.toolSet.price);
      lines.push('<div class="byb-summary-line">' +
        '<span class="byb-summary-item">' + thumb(state.toolSet.thumb) +
        '<span class="byb-summary-name">' + esc(state.toolSet.title) + '</span></span>' +
        '<span class="byb-summary-price">' + money(state.toolSet.price) + '</span></div>');
    }
    lines.push('<div class="byb-summary-line byb-summary-line--total"><strong>Total</strong><strong>' + money(total) + '</strong></div>');
    summary.innerHTML = lines.join('');

    // Carry the build through to the quote form, when one is configured.
    var quote = document.getElementById('byb-quote');
    if (quote && data.quoteUrl) {
      var sep = data.quoteUrl.indexOf('?') > -1 ? '&' : '?';
      quote.href = data.quoteUrl + sep + 'build=' + encodeURIComponent(location.href);
    }
  }

  // Secondary actions. Both are local — nothing is sent anywhere.
  var statusEl = document.getElementById('byb-add-status');
  var shareBtn = document.getElementById('byb-share');
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      writeUrl();
      var url = location.href;
      function fallback() {
        // Clipboard access is refused in plenty of ordinary situations (no
        // HTTPS, permissions policy, older Safari). Showing the URL is a worse
        // experience than copying it, but it is not a dead button.
        if (statusEl) statusEl.textContent = 'Copy this link: ' + url;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          if (statusEl) statusEl.textContent = 'Link copied — it reopens this exact build.';
        }).catch(fallback);
      } else {
        fallback();
      }
    });
  }

  var printBtn = document.getElementById('byb-print');
  if (printBtn) {
    printBtn.addEventListener('click', function () { window.print(); });
  }

  var addBtn = document.getElementById('byb-add-all');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      // Without the disabled guard a double-tap fired two /cart/add.js calls and
      // added two of everything.
      if (addBtn.disabled || !state.box) return;
      var items = [{ id: boxVariantId(), quantity: 1 }];
      if (state.toolSet) items.push({ id: state.toolSet.variantId, quantity: 1 });

      addBtn.disabled = true;
      if (statusEl) statusEl.textContent = 'Adding to cart…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().catch(function () { return null; }).then(function (body) {
          if (!res.ok) {
            // Shopify puts the useful reason (out of stock, quantity limits) in
            // `description`; the old catch-all discarded it.
            throw new Error((body && (body.description || body.message)) || 'Cart add failed');
          }
          window.location.href = '/cart';
        });
      }).catch(function (err) {
        addBtn.disabled = false;
        if (statusEl) statusEl.textContent = (err && err.message) || 'Something went wrong adding to cart — please try again.';
      });
    });
  }

  // -------------------------------------------------------------------------
  // Boot
  // -------------------------------------------------------------------------
  if (!restoreFromUrl()) {
    renderBoxGrid();
    renderTrail();
    renderTotalBar();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
